/**
 * 初始化应用配置
 * 负责从 URL 参数获取渠道号、产品线、平台等信息并存储到 appStore
 */

import { getQueryVariable } from './apiUtils';
import { useAppStore } from '@/stores/appStore';

/**
 * 初始化应用配置（在应用启动时调用）
 * 将 URL 参数中的各项配置清洗、存到 appStore
 */
export function initAppConfig(): void {
  const configParams: Record<string, string> = {
    vChannelId: getQueryVariable('v_channel_id')?.trim() || '',
    prodLine: getQueryVariable('prod_line')?.trim() || '',
    platform: getQueryVariable('platform')?.trim() || '',
  };

  const { setVChannelId, setProdLine, setPlatform } = useAppStore.getState();

  // 集中分配处理
  if (configParams.vChannelId) setVChannelId(configParams.vChannelId);
  if (configParams.prodLine) setProdLine(configParams.prodLine);
  if (configParams.platform) setPlatform(configParams.platform);

  // 开发环境下友好输出
  if (process.env.NODE_ENV === 'development') {
    console.log('📱 应用配置初始化:', {
      vChannelId: configParams.vChannelId,
      prodLine: configParams.prodLine,
      platform: configParams.platform,
    });
  }
}
